import Svg, {
  ClipPath,
  Defs,
  FeBlend,
  FeColorMatrix,
  FeComposite,
  FeFlood,
  FeGaussianBlur,
  FeMorphology,
  FeOffset,
  Filter,
  G,
  Path,
  Rect,
  TSpan,
  Text,
} from 'react-native-svg';

export const AccumulateBalanceActivityAsset = ({
  width = 302,
  height = 331,
  benefitTitle,
  cardTitle,
  cardValue,
  activityTitle,
  className,
}: TAccumulateBalanceActivityAssetProps) => {
  return (
    <Svg
      className={className}
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 302 332"
    >
      <G clipPath="url(#accumulate-balance-activity-asset-a)">
        <Path
          fill="#FCF5F2"
          stroke="#FDBD9A"
          strokeWidth="3.869"
          d="M1.934 29.32c0-15.125 12.261-27.386 27.386-27.386h211.107c15.125 0 27.386 12.262 27.386 27.386v304.464H1.934V29.32Z"
        />
        <Text
          fill="#5F7287"
          fontFamily="F37 Ginger Pro"
          fontSize="20.524"
          fontWeight="bold"
          letterSpacing="0"
        >
          <TSpan x="62.471" y="55.551">
            {benefitTitle}
          </TSpan>
        </Text>
        <Text
          fill="#5F7287"
          fontFamily="F37 Ginger Pro"
          fontSize="11.728"
          fontWeight="bold"
          letterSpacing="0"
        >
          <TSpan x="214.969" y="305.224">
            -€€
          </TSpan>
        </Text>
        <Path
          fill="#8E9CAB"
          d="M56.684 301.104c0-.28.065-.527.196-.741.123-.222.295-.394.517-.517.214-.131.461-.196.741-.196h5.503c.28 0 .526.065.741.196.221.123.394.295.517.517.13.214.195.461.195.741v.02c0 .279-.065.53-.195.751a1.413 1.413 0 0 1-.517.517 1.455 1.455 0 0 1-.741.185h-5.503c-.28 0-.527-.061-.741-.185a1.412 1.412 0 0 1-.517-.517 1.454 1.454 0 0 1-.196-.751v-.02Z"
        />
        <Path
          fill="#FF8E7A"
          d="M49.085 39.427c.592 0 1.115.523 1.115 1.115V56.16c0 .628-.523 1.116-1.115 1.116a1.101 1.101 0 0 1-1.116-1.116v-4.462h-1.116a2.203 2.203 0 0 1-2.23-2.231v-3.905c0-5.02 3.904-6.135 4.462-6.135Zm-12.272.557v4.707c0 .174.14.313.314.313.21 0 .349-.104.349-.313l.453-4.741c0-.28.244-.523.558-.523.279 0 .523.244.523.523l.453 4.74c0 .21.174.314.349.314.174 0 .348-.139.348-.313v-4.707c0-.279.21-.523.488-.523a.536.536 0 0 1 .593.419l1.046 4.74c.07.245.104.454.104.663 0 1.604-1.255 2.929-2.789 3.068v7.809c0 .628-.523 1.116-1.115 1.116a1.101 1.101 0 0 1-1.116-1.116v-7.809a3.073 3.073 0 0 1-2.789-3.068c0-.209 0-.418.07-.662l1.046-4.741a.536.536 0 0 1 .593-.419c.278 0 .523.245.523.523Zm1.674 5.3h-.035.035Z"
        />
        <Path
          fill="#8E9CAB"
          d="M62.163 301.104c0-.28.065-.527.195-.741.123-.222.296-.394.517-.517.215-.131.462-.196.741-.196h5.503c.28 0 .527.065.742.196.22.123.393.295.517.517.13.214.195.461.195.741v.02c0 .279-.065.53-.195.751a1.413 1.413 0 0 1-.517.517 1.455 1.455 0 0 1-.742.185h-5.503c-.28 0-.526-.061-.741-.185a1.411 1.411 0 0 1-.517-.517 1.454 1.454 0 0 1-.195-.751v-.02Z"
        />
        <Path
          fill="#FF8E7A"
          d="M44.201 294.281c.417 0 .784.367.784.784V306.041a.79.79 0 0 1-.784.784.774.774 0 0 1-.784-.784v-3.136h-.784a1.548 1.548 0 0 1-1.568-1.568v-2.744c0-3.528 2.744-4.312 3.136-4.312Zm-8.624.392v3.307a.22.22 0 0 0 .22.221c.148 0 .246-.074.246-.221l.318-3.332c0-.196.172-.367.392-.367.196 0 .368.171.368.367l.318 3.332c0 .147.123.221.245.221.123 0 .245-.098.245-.221v-3.307c0-.196.147-.368.343-.368a.377.377 0 0 1 .417.294l.735 3.332c.049.172.073.319.073.466a2.179 2.179 0 0 1-1.96 2.156v5.488a.79.79 0 0 1-.784.784.774.774 0 0 1-.784-.784v-5.488a2.16 2.16 0 0 1-1.96-2.156c0-.147 0-.294.05-.466l.734-3.332a.377.377 0 0 1 .417-.294c.196 0 .367.172.367.368Zm1.176 3.724h-.024.024Z"
        />
        <Path
          fill="#8E9CAB"
          d="M67.641 301.104c0-.28.065-.527.195-.741.124-.222.296-.394.517-.517.215-.131.462-.196.742-.196h5.502c.28 0 .527.065.742.196.221.123.393.295.517.517.13.214.195.461.195.741v.02c0 .279-.065.53-.195.751a1.413 1.413 0 0 1-.517.517 1.455 1.455 0 0 1-.742.185h-5.502c-.28 0-.527-.061-.742-.185a1.412 1.412 0 0 1-.517-.517 1.454 1.454 0 0 1-.195-.751v-.02Z"
        />
        <Path
          fill="#8E9CAB"
          d="M73.12 301.104c0-.28.065-.527.195-.741.123-.222.296-.394.517-.517.214-.131.462-.196.741-.196h5.503c.28 0 .527.065.741.196.222.123.394.295.517.517.13.214.195.461.195.741v.02c0 .279-.064.53-.195.751a1.412 1.412 0 0 1-.517.517 1.455 1.455 0 0 1-.741.185h-5.503c-.28 0-.527-.061-.741-.185a1.412 1.412 0 0 1-.517-.517 1.454 1.454 0 0 1-.195-.751v-.02Z"
        />
        <Path
          fill="#8E9CAB"
          d="M78.598 301.104c0-.28.065-.527.195-.741.124-.222.296-.394.517-.517.215-.131.462-.196.742-.196h2.81c.28 0 .526.065.741.196.221.123.394.295.517.517.13.214.195.461.195.741v.02c0 .279-.065.53-.195.751a1.413 1.413 0 0 1-.517.517 1.455 1.455 0 0 1-.741.185h-2.81c-.28 0-.527-.061-.742-.185a1.412 1.412 0 0 1-.517-.517 1.454 1.454 0 0 1-.195-.751v-.02Z"
        />
        <Path
          fill="#8E9CAB"
          d="M81.39 301.104c0-.28.065-.527.195-.741.123-.222.296-.394.517-.517.214-.131.462-.196.741-.196h5.503c.28 0 .527.065.741.196.221.123.394.295.517.517.13.214.195.461.195.741v.02c0 .279-.065.53-.195.751a1.412 1.412 0 0 1-.517.517 1.455 1.455 0 0 1-.741.185h-5.503c-.28 0-.527-.061-.741-.185a1.413 1.413 0 0 1-.517-.517 1.454 1.454 0 0 1-.195-.751v-.02Z"
        />
        <Path
          fill="#8E9CAB"
          d="M86.868 301.104c0-.28.065-.527.195-.741.124-.222.296-.394.517-.517.215-.131.462-.196.742-.196h2.81c.28 0 .526.065.741.196.221.123.393.295.517.517.13.214.195.461.195.741v.02c0 .279-.065.53-.195.751a1.413 1.413 0 0 1-.517.517 1.455 1.455 0 0 1-.742.185h-2.81c-.279 0-.526-.061-.74-.185a1.413 1.413 0 0 1-.518-.517 1.454 1.454 0 0 1-.195-.751v-.02Z"
        />
        <Path
          fill="#8E9CAB"
          d="M89.66 301.104c0-.28.065-.527.195-.741.123-.222.296-.394.517-.517.215-.131.462-.196.741-.196h2.81c.28 0 .527.065.742.196.22.123.393.295.517.517.13.214.195.461.195.741v.02c0 .279-.065.53-.195.751a1.413 1.413 0 0 1-.517.517 1.455 1.455 0 0 1-.742.185h-2.81c-.28 0-.526-.061-.741-.185a1.413 1.413 0 0 1-.517-.517 1.454 1.454 0 0 1-.195-.751v-.02Z"
        />
        <Path
          fill="#8E9CAB"
          d="M92.451 301.104c0-.28.065-.527.195-.741.124-.222.296-.394.517-.517.215-.131.462-.196.742-.196h5.502c.28 0 .527.065.742.196.221.123.393.295.517.517.13.214.195.461.195.741v.02c0 .279-.065.53-.195.751a1.416 1.416 0 0 1-.517.517 1.455 1.455 0 0 1-.742.185h-5.502c-.28 0-.527-.061-.742-.185a1.413 1.413 0 0 1-.517-.517 1.455 1.455 0 0 1-.195-.751v-.02ZM103.78 301.104c0-.28.065-.527.195-.741.123-.222.296-.394.517-.517.214-.131.462-.196.741-.196h5.503c.28 0 .527.065.741.196.222.123.394.295.517.517.131.214.196.461.196.741v.02a1.446 1.446 0 0 1-.713 1.268 1.45 1.45 0 0 1-.741.185h-5.503c-.279 0-.527-.061-.741-.185a1.409 1.409 0 0 1-.517-.517 1.455 1.455 0 0 1-.195-.751v-.02Z"
        />
        <Path
          fill="#8E9CAB"
          d="M109.258 301.104c0-.28.065-.527.195-.741.124-.222.296-.394.517-.517.215-.131.462-.196.742-.196h5.502c.28 0 .527.065.742.196.221.123.393.295.517.517.13.214.195.461.195.741v.02c0 .279-.065.53-.195.751a1.416 1.416 0 0 1-.517.517 1.457 1.457 0 0 1-.742.185h-5.502c-.28 0-.527-.061-.742-.185a1.416 1.416 0 0 1-.517-.517 1.455 1.455 0 0 1-.195-.751v-.02Z"
        />
        <Path
          fill="#8E9CAB"
          d="M114.736 301.104c0-.28.065-.527.196-.741.123-.222.296-.394.517-.517a1.39 1.39 0 0 1 .741-.196h5.503c.279 0 .527.065.741.196.221.123.394.295.517.517.13.214.195.461.195.741v.02c0 .279-.065.53-.195.751a1.409 1.409 0 0 1-.517.517 1.453 1.453 0 0 1-.741.185h-5.503a1.45 1.45 0 0 1-.741-.185 1.446 1.446 0 0 1-.713-1.268v-.02Z"
        />
        <Path
          fill="#8E9CAB"
          d="M120.215 301.104c0-.28.065-.527.195-.741.124-.222.296-.394.517-.517.215-.131.462-.196.742-.196h2.809c.28 0 .527.065.742.196.221.123.393.295.517.517.13.214.195.461.195.741v.02c0 .279-.065.53-.195.751a1.416 1.416 0 0 1-.517.517 1.457 1.457 0 0 1-.742.185h-2.809c-.28 0-.527-.061-.742-.185a1.416 1.416 0 0 1-.517-.517 1.455 1.455 0 0 1-.195-.751v-.02Z"
        />
        <Path
          fill="#8E9CAB"
          d="M123.006 301.104c0-.28.066-.527.196-.741.123-.222.296-.394.517-.517a1.39 1.39 0 0 1 .741-.196h2.81c.28 0 .527.065.741.196.222.123.394.295.518.517.13.214.195.461.195.741v.02c0 .279-.065.53-.195.751a1.411 1.411 0 0 1-.518.517 1.45 1.45 0 0 1-.741.185h-2.81a1.45 1.45 0 0 1-.741-.185 1.409 1.409 0 0 1-.517-.517 1.456 1.456 0 0 1-.196-.751v-.02Z"
        />
        <Path
          fill="#8E9CAB"
          d="M125.798 301.104c0-.28.065-.527.195-.741.124-.222.296-.394.517-.517.215-.131.462-.196.742-.196h5.502c.28 0 .527.065.742.196.221.123.393.295.517.517.13.214.195.461.195.741v.02c0 .279-.065.53-.195.751a1.416 1.416 0 0 1-.517.517 1.457 1.457 0 0 1-.742.185h-5.502c-.28 0-.527-.061-.742-.185a1.416 1.416 0 0 1-.517-.517 1.455 1.455 0 0 1-.195-.751v-.02Z"
        />
        <Path
          fill="#8E9CAB"
          d="M131.276 301.104c0-.28.066-.527.196-.741.123-.222.296-.394.517-.517a1.39 1.39 0 0 1 .741-.196h2.81c.28 0 .527.065.741.196.222.123.394.295.518.517.13.214.195.461.195.741v.02c0 .279-.065.53-.195.751a1.411 1.411 0 0 1-.518.517 1.45 1.45 0 0 1-.741.185h-2.81a1.45 1.45 0 0 1-.741-.185 1.409 1.409 0 0 1-.517-.517 1.456 1.456 0 0 1-.196-.751v-.02Z"
        />
        <Path
          fill="#8E9CAB"
          d="M134.068 301.104c0-.28.065-.527.195-.741.124-.222.296-.394.517-.517.215-.131.462-.196.742-.196h5.502c.28 0 .527.065.742.196.221.123.393.295.517.517.13.214.195.461.195.741v.02c0 .279-.065.53-.195.751a1.416 1.416 0 0 1-.517.517 1.457 1.457 0 0 1-.742.185h-5.502c-.28 0-.527-.061-.742-.185a1.416 1.416 0 0 1-.517-.517 1.455 1.455 0 0 1-.195-.751v-.02Z"
        />
        <Text
          fill="#5F7287"
          fontFamily="F37 Ginger Pro"
          fontSize="11.728"
          fontWeight="bold"
          letterSpacing="0"
        >
          <TSpan x="32.853" y="265.155">
            {activityTitle}
          </TSpan>
        </Text>
        <G filter="url(#accumulate-balance-activity-asset-b)">
          <Rect
            width="265.35"
            height="127.544"
            x="20.08"
            y="98.993"
            fill="#F7F8FA"
            rx="15.079"
          />
        </G>
        <G filter="url(#accumulate-balance-activity-asset-c)">
          <Rect
            width="265.35"
            height="127.544"
            x="36.206"
            y="82.867"
            fill="#F8FBFC"
            rx="15.079"
          />
          <G filter="url(#accumulate-balance-activity-asset-d)">
            <Rect
              width="78"
              height="47"
              x="204.655"
              y="145.338"
              fill="#7CCCC5"
              rx="23.5"
            />
          </G>
          <Path
            fill="#fff"
            d="M237.754 168.338c0-11.86 9.614-21.474 21.474-21.474s21.475 9.614 21.475 21.474-9.615 21.475-21.475 21.475c-11.86 0-21.474-9.615-21.474-21.475Z"
          />
          <Path
            fill="#3AA097"
            d="M270.652 160.416a1.646 1.646 0 0 1 0 2.402l-13.666 13.666a1.646 1.646 0 0 1-2.402 0l-6.833-6.833a1.646 1.646 0 0 1 0-2.402 1.646 1.646 0 0 1 2.402 0l5.659 5.605 12.437-12.438a1.647 1.647 0 0 1 2.403 0Z"
          />
        </G>
        <Text
          fill="#333E4A"
          fontFamily="F37 Ginger Pro"
          fontSize="20.524"
          fontWeight="bold"
          letterSpacing="0"
        >
          <TSpan x="55.264" y="123.917">
            {cardTitle}
          </TSpan>
        </Text>
        <Text
          fill="#333E4A"
          fontFamily="F37 Ginger Pro"
          fontSize="41.048"
          fontWeight="bold"
          letterSpacing="0"
        >
          <TSpan x="55.264" y="183.184">
            {cardValue}
          </TSpan>
        </Text>
      </G>
      <Defs>
        <Filter
          id="accumulate-balance-activity-asset-d"
          width="298.021"
          height="160.215"
          x="3.744"
          y="91.454"
          filterUnits="userSpaceOnUse"
        >
          <FeFlood floodOpacity="0" result="BackgroundImageFix" />
          <FeColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <FeOffset dy="8.796" />
          <FeGaussianBlur stdDeviation="8.168" />
          <FeComposite in2="hardAlpha" operator="out" />
          <FeColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
          <FeBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1569_33545"
          />
          <FeBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_1569_33545"
            result="shape"
          />
        </Filter>
        <Filter
          id="accumulate-balance-activity-asset-c"
          width="335.719"
          height="197.913"
          x="1.022"
          y="71.139"
          filterUnits="userSpaceOnUse"
        >
          <FeFlood floodOpacity="0" result="BackgroundImageFix" />
          <FeColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <FeMorphology
            in="SourceAlpha"
            radius="11.728"
            result="effect1_dropShadow_1569_33545"
          />
          <FeOffset dy="23.456" />
          <FeGaussianBlur stdDeviation="23.456" />
          <FeColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
          <FeBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1569_33545"
          />
          <FeBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_1569_33545"
            result="shape"
          />
        </Filter>
        <Filter
          id="accumulate-balance-activity-asset-b"
          width="78"
          height="47"
          x="204.655"
          y="145.338"
          filterUnits="userSpaceOnUse"
        >
          <FeFlood floodOpacity="0" result="BackgroundImageFix" />
          <FeBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <FeColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <FeOffset />
          <FeGaussianBlur stdDeviation="3.904" />
          <FeComposite in2="hardAlpha" k2="1" k3="1" operator="arithmetic" />
          <FeColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
          <FeBlend in2="shape" result="effect1_innerShadow_1569_33545" />
        </Filter>
        <ClipPath id="accumulate-balance-activity-asset-a">
          <Path fill="#fff" d="M0 0h302v331.32H0z" />
        </ClipPath>
      </Defs>
    </Svg>
  );
};

export type TAccumulateBalanceActivityAssetProps = {
  width?: number;
  height?: number;
  benefitTitle?: string;
  cardTitle?: string;
  cardValue?: string;
  activityTitle?: string;
  className?: string;
};
